import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function NoPermission() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Get user data from localStorage
    const userDataStr = localStorage.getItem("user");
    const userData = userDataStr ? JSON.parse(userDataStr) : null;
    if (userData) {
      setUser(userData);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("userPermissions");
    navigate("/login");
  };

  return (
    <div className="container-xxl">
      <div className="row vh-100 d-flex justify-content-center">
        <div className="col-12 align-self-center">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-6 mx-auto">
                <div className="card">
                  <div className="card-body p-5">
                    <div className="text-center">
                      <img
                        src="assets/images/extra/card/maintenance.png"
                        alt=""
                        className="img-fluid mb-3"
                        style={{ maxWidth: "200px" }}
                      />
                      <h6 className="mb-2 fw-medium text-dark fs-24">
                        Access Denied
                      </h6>
                      <p className="text-muted mb-0 text-wrap fs-15">
                        Sorry, you don't have permission to access this system. 
                        <br />
                        Please contact an administrator to get proper access.
                      </p>
                      <div className="mt-4 text-center">
                        <button 
                          className="btn btn-primary me-2" 
                          onClick={handleLogout}
                        >
                          <i className="fas fa-sign-out-alt me-1" />
                          Back to Login
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoPermission;
